var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 3.5999C2.3999 3.28164 2.52633 2.97642 2.75137 2.75137C2.97642 2.52633 3.28164 2.3999 3.5999 2.3999H6.1835C6.46755 2.40003 6.74234 2.50092 6.959 2.68461C7.17565 2.86831 7.32012 3.1229 7.3667 3.4031L8.2547 8.7251C8.29713 8.97856 8.25707 9.23895 8.14042 9.46794C8.02377 9.69693 7.83668 9.88242 7.6067 9.9971L5.7491 10.9247C6.41523 12.5755 7.4073 14.075 8.66603 15.3338C9.92476 16.5925 11.4243 17.5846 13.0751 18.2507L14.0039 16.3931C14.1185 16.1633 14.3038 15.9764 14.5326 15.8598C14.7613 15.7431 15.0214 15.7029 15.2747 15.7451L20.5967 16.6331C20.8769 16.6797 21.1315 16.8242 21.3152 17.0408C21.4989 17.2575 21.5998 17.5323 21.5999 17.8163V20.3999C21.5999 20.7182 21.4735 21.0234 21.2484 21.2484C21.0234 21.4735 20.7182 21.5999 20.3999 21.5999H17.9999C9.3839 21.5999 2.3999 14.6159 2.3999 5.9999V3.5999Z",
    fill: "#0052FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.a7ad767bfbad24de65a9f45c5a4d5728.svg";
export { ForwardRef as ReactComponent };